<template>
	<div class="ticket" :class="{ expired: !product.redeemed && (isExpired || isEnded) }">
		<div class="align-center d-flex flex-column position-relative ticket-top">
			<h5 v-if="venue" class="font-weight-medium grey--text text--darken-1 mb-1 mt-4">
				{{ venue.name }}
			</h5>
			<h4 class="mb-1 mt-4">
				{{ product.name }}
				<span v-if="product.attributeName">{{ ' - ' + product.attributeName }}</span>
			</h4>
			<!-- HR is only shown with venue location on -->
			<hr
				aria-orientation="horizontal"
				class="my-4 opacity-50 w-100 v-divider theme--light"
				role="separator"
			/>
			<h6 class="font-weight-medium grey--text my-4">{{ product.venueLocationName }}</h6>
			<!-- End: venue location -->
			<!-- If Master Voucher -->
			<h5 v-if="product.distribution" class="my-4">
				( {{ product.distribution.first_name + ' ' + product.last_name }} )
			</h5>
			<!-- End: If Master Voucher -->
			<div class="mb-4 px-4 w-100">
				<div
					v-if="product.showTicket[0] && product.ticketType"
					class="px-4 py-2 text-center text-body-1 ticket-instructions w-100"
				>
					<!-- If Line 1 - Above -->
					<div
						v-if="product.line_1 && product.ticketType !== 'html'"
						class="mb-2 text-body-2"
					>
						{{ product.line_1 }}
					</div>
					<!-- End: Line 1 - Above -->
					<span v-if="product.ticketType === 'barcode'">
						<span v-if="product.barcodeType === 'QRCODE'">
							<img
								:src="'/api/barcode/' + product.value + '?type=' + product.barcodeType"
								style="max-width: 50%"
							/>
						</span>
						<span v-else>
							<img
								:src="
									'/api/barcode/' +
									product.value +
									'?type=' +
									product.barcodeType +
									'&height=55'
								"
								style="max-width: 100%"
							/>
						</span>
					</span>
					<span v-else-if="product.ticketType === 'image'">
						<img :src="product.value" style="width: 90%; margin: 10px auto" />
					</span>
					<span
						v-else-if="
							product.ticketType === 'html' || product.ticketType === 'promo_code'
						"
					>
						<div
							style="
								width: 100%;
								text-align: center;
								font-size: 16px;
								word-break: break-word;
							"
							v-html="product.value"
						></div>
					</span>
					<!-- If Line 2 - Below -->
					<div
						v-if="product.line_2 && product.ticketType !== 'html'"
						class="mt-2 text-body-2"
					>
						<div
							style="
								padding-top: 5px;
								width: 100%;
								text-align: center;
								font-size: 16px;
								word-break: break-word;
							"
						>
							{{ product.line_2 }}
						</div>
					</div>
					<!-- End: Line 2 - Below -->
				</div>
				<div
					v-else-if="product.showTicket[1]"
					style="px-4 py-2 text-center text-body-1 ticket-instructions w-100"
				>
					{{ product.showTicket[1] }}
				</div>
			</div>
			<div
				v-if="
					isStarted && !isEnded && !isExpired && product.canRedeem[0] && product.end_date
				"
				class="grey--text mb-4 text-body-2"
			>
				Valid until: {{ Bandwango.dateToLocal(product.end_date, false, dateFormat) }}
			</div>
		</div>
		<div class="align-center d-flex flex-column position-relative ticket-bottom">
			<v-divider class="w-100"></v-divider>
			<template v-if="product.redeemed">
				<v-btn
					
					block
					class="rounded-t-0 rounded-b-lg success--text text--darken-1"
					color="rgba(76, 175, 80, 0.05)"
					depressed
					x-large
				>
					<v-icon color="success">mdi-check-circle</v-icon>
					{{ Bandwango.dateToLocal(product.redeemed, false, dateFormat) }}
				</v-btn>
			</template>
			<template v-else-if="isEnded || isExpired">
				
				<span v-if="isEnded">
						Expired: {{ Bandwango.dateToLocal(product.end_date, false, dateFormat) }}
					</span>
				<v-span v-else-if="isExpired">
					Expired: {{ Bandwango.dateToLocal(product.expire_date, false, dateFormat) }}
				</v-span>
				<span v-else-if="!product.canRedeem[0]">
						{{ product.canRedeem[1] }}
					</span>
				<v-btn
					block
					class="rounded-t-0 rounded-b-lg error--text text--darken-1"
					:color="product.isRedeeming ? 'success' :  'rgba(255, 0, 0, 0.05)'"
					depressed
					x-large
					:disabled="!product.canRedeem[0]"
					@click="() => { if(product.canRedeem[0]) redeemTicket() }"
				>
					<span v-if="product.isRedeeming">
						<v-icon color="black">mdi-check</v-icon>
					</span>
					<span v-else>
						{{
							(product.languageTags && product.languageTags['TAP_TO_SELECT']) ||
							'Tap To Select'
						}}
					</span>
				</v-btn>
			</template>
			<template v-else>
				
				<span v-if="!isStarted">
						Available starting  :
						{{ Bandwango.dateToLocal(product.start_date, false, dateFormat) }}
					</span>
				<span v-else>
						<span v-if="product.canRedeem[0]">
							
						</span>
						<span v-else>
							{{ product.canRedeem[1] }}
						</span>
					</span>
				<v-btn
					
					block
					class="rounded-t-0 rounded-b-lg success--text"
					:color="product.isRedeeming ? 'success' : 'white'"
					depressed
					x-large
					:disabled="!product.canRedeem[0]"
					@click="() => { if(product.canRedeem[0]) redeemTicket() }"
				>
					<span v-if="product.isRedeeming">
						<v-icon color="white">mdi-check</v-icon>
					</span>
					<span v-else>
						{{
							(product.languageTags && product.languageTags['TAP_TO_SELECT']) ||
							'Tap To Select'
						}}
					</span>
				</v-btn>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Ticket',
	props: {
		// product includes ticket, vice/versa or fully separate...
		product: {
			type: Object,
			default: () => ({})
		},
		venue: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			dateFormat: 'MMM Do Y, h:mm:s a'
		};
	},
	methods: {
		redeemTicket() {
			this.product.isRedeeming = !this.product.isRedeeming;
			this.$emit('select-product', this.product);
			this.$forceUpdate();
		}
	},
	computed: {
		isExpired() {
			return (
				this.product.expire_date && moment(this.product.expire_date).isBefore(moment())
			);
		},
		isEnded() {
			return this.product.end_date && moment(this.product.end_date).isBefore(moment());
		},
		isStarted() {
			return (
				!this.product.start_date || moment(this.product.start_date).isBefore(moment())
			);
		}
	}
};
</script>

<style>
.ticket {
	background: white;
	border: solid 8px black;
	border-radius: 1rem;
	margin-bottom: 1rem;
	max-width: 800px;
	width: 100%;
}
.ticket-instructions {
	background: #fafafa;
	border: solid 1px #cccccc;
	border-radius: 0.5rem;
}
.ticket-bottom::before,
.ticket-bottom::after {
	background-color: black;
	border-radius: 8px;
	content: '';
	height: 16px;
	position: absolute;
	width: 16px;
	z-index: 5;
}
.ticket-bottom::before {
	top: -7px;
	left: -8px;
}
.ticket-bottom::after {
	top: -7px;
	right: -8px;
}

.ticket.expired {
	border: solid 8px red;
}

.ticket.expired .ticket-bottom::before,
.ticket.expired .ticket-bottom::after {
	background-color: red;
}
</style>
